import { Sites } from '@ps/platform-message-framework/common/Sites';
import { ResolverTag } from '@ps/web-core-enums';
import { StarsButton as Button, Translation } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ButtonGroup from '@swf/components/ButtonGroup/ButtonGroup';
import ResolverLink from '@swf/components/ResolverLink/ResolverLink';
import Body from '@swf/components/StarsModal/components/Body';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import {
  TXTCLI_Login_information,
  TXTCLI_OK,
  TXTWCL_Account_Information,
  TXTWCL_For_more_informationX_please_v_ELL_1,
  TXTWCL_In_the_meantimeX_we_can_direct_ELL,
  TXTWCL_Our_team_is_actively_looking_i_ELL,
  TXTWCL_SorryX_your_account_is_restric_ELL,
  TXTWCL_These_checks_donXt_take_longX__ELL,
  TXTWCL_WeXll_email_you_if_we_need_fur_ELL,
  TXTWCL_WeXve_limited_your_real_money__ELL,
  TXTWCL_Your_account_has_been_temporar_ELL_1
} from './SecurityInvestigation.messages.json';
import styles from './SecurityInvestigation.scss';

const SecurityInvestigation: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const isCAON = useSelector(select.cms.getSiteId) === Sites.CA_ON;
  const email = useSelector(select.account.getEmail);

  return (
    <>
      <Header>
        <Translation {...(isCAON ? TXTWCL_Account_Information : TXTCLI_Login_information)} />
        <CloseButton />
      </Header>
      <Body>
        {isCAON && <Translation tagName="h3" {...TXTWCL_SorryX_your_account_is_restric_ELL} />}
        {isCAON ? (
          <>
            <p className={styles.message}>
              <Translation {...TXTWCL_WeXve_limited_your_real_money__ELL} />
            </p>
            <p className={styles.message}>
              <Translation {...TXTWCL_These_checks_donXt_take_longX__ELL} />
            </p>
            <p className={styles.message}>
              <Translation {...TXTWCL_WeXll_email_you_if_we_need_fur_ELL} />
              <br />
              <Translation
                {...TXTWCL_For_more_informationX_please_v_ELL_1}
                values={{
                  a: (msg: React.ReactNode) => (
                    <ResolverLink resolverTag={ResolverTag.RealMoneySecurityFaq}>
                      {msg}
                    </ResolverLink>
                  )
                }}
              />
            </p>
          </>
        ) : (
          <>
            <p className={styles.message}>
              <Translation {...TXTWCL_Your_account_has_been_temporar_ELL_1} />
            </p>
            <p className={styles.message}>
              <Translation
                {...TXTWCL_Our_team_is_actively_looking_i_ELL}
                values={{ 0: email, i: (msg: React.ReactNode) => <i>{msg}</i> }}
              />
            </p>
            <p className={styles.message}>
              <Translation
                {...TXTWCL_In_the_meantimeX_we_can_direct_ELL}
                values={{
                  a: (msg: React.ReactNode) => (
                    <ResolverLink resolverTag={ResolverTag.RealMoneySecurityFaq}>
                      {msg}
                    </ResolverLink>
                  )
                }}
              />
            </p>
          </>
        )}
        <ButtonGroup>
          <Button block onClick={() => modal.close()} translation={TXTCLI_OK} />
        </ButtonGroup>
      </Body>
    </>
  );
};

export default SecurityInvestigation;
